module.exports = __webpack_public_path__ + "img/undertakingCases13.82c46433.jpg";